import classnames from 'classnames';
import { createElement } from 'react';
CardBody.defaultProps = {
    prefixCls: 'im-card',
};
export default function CardBody(props) {
    const { prefixCls, className, content, full, borderRadius, ...restProps } = props;
    let wrapCls;
    if (full) {
        wrapCls = classnames(`${prefixCls}-body-full`, className);
    }
    else {
        wrapCls = classnames(`${prefixCls}-body`, className);
    }
    return (createElement("div", Object.assign({ className: wrapCls, style: { borderRadius: `${borderRadius}px` } }, restProps), content));
}
